import i18n from 'i18next';
import { registerValidator } from 'core/forms';

const isUrlSlug = ({ fieldValue }) => ({
  error: i18n.t('error-not-url-slug'),
  hasError: !/^[a-zA-Z0-9\-_]+$/.test(fieldValue),
});

registerValidator('isUrlSlug', isUrlSlug);

export default isUrlSlug;
